import styled, { Scale } from '@secretescapes/falcon';

export const PayPalMessagesWrapper = styled('div')`
  padding: ${Scale.m} ${Scale.m} 0 ${Scale.m};
`;
